<div class="mct-grid mct-cols-1 mct-gap-20"  >
  <label>{{ 'ecommerce.item.images.header' | translate | ucfirst }}</label>
  <label>{{ 'ecommerce.item.images.primary-images-usage' | translate | ucfirst }}</label>
  <label>{{ 'ecommerce.item.images.sub-header' | translate | ucfirst }}</label>

  <th *ngIf="!eCommerceItem?.ImageUrl">{{ 'ecommerce.item.images.no-image' | translate | ucfirst }}</th>
  <div>
    <div>
      <img [src]="eCommerceItem?.ImageUrl || './assets/img/no-image.png'" width="300" />
    </div>
    <div *ngIf="eCommerceItem?.ImageUrl"    class="mt-10 mct-gap-180 mct-flex mct-row mct-justify-start mct-items-center">
      <label><input type="radio" name="Primary" [checked]="true" style="margin-right: 5px;" />{{ 'ecommerce.item.images.primary' | translate | titlecase }}</label>
      <a (click)="deletePrimaryImage(eCommerceItem.ImageUrl)"> {{ 'common.delete' | translate | ucfirst }}</a>
    </div>
  </div>
  <wl-busy [show]="isLoading"></wl-busy>
  <div class="mct-flex mct-row mct-justify-start mct-items-end"  >
    <div  class="mr-20 mb-50 mct-flex mct-col" *ngFor="let image of eComItemImages; let i = index">
      <div>
        <img [src]="image.S3Url" alt="{{ 'ecommerce.item.images.no-image-txt' | translate }}" width="150" />
      </div>
      <div    class="mt-10 mct-flex mct-row mct-justify-start mct-items-center mct-gap-40">
        <label
          ><input
            type="radio"
            name="rbtGrpPrimary"
            [value]="i"
            [checked]="eCommerceItem.ImageUrl === image.S3Url"
            (change)="isPrimaryChanged(i)"
            style="margin-right: 5px"
          />{{ 'ecommerce.item.images.primary' | translate | titlecase }}</label
        >
        <a (click)="deleteImage(i)"> {{ 'common.delete' | translate | ucfirst }}</a>
      </div>
    </div>
  </div>
</div>

<input #uploader type="file" hidden multiple="" accept="image/*" (change)="onFileChange($event)" />
<button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="awaitingResponse" (click)="uploader.click()">
  <span *ngIf="!awaitingResponse">{{ 'ecommerce.item.images.btn-text' | translate | uppercase }}</span>
  <wl-busy *ngIf="awaitingResponse" [show]="true"></wl-busy>
</button>
